// extracted by mini-css-extract-plugin
export default {"shipping_details":"ShippingForm_shipping_details__0JnPn"};